import React from "react";

export default function StoriesSection({ stories }) {
  const items = stories || [];
  if (!items.length) return null;
  return (
    <section data-testid="stories-section" className="py-16 md:py-28 border-t border-[color:var(--border)]">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="mb-10 md:mb-16">
          <div className="eyebrow mb-3">The Journal</div>
          <h2 className="font-display italic text-4xl md:text-6xl leading-[1] tracking-tight">Wedding Stories</h2>
        </div>

        <div className="flex flex-col gap-16 md:gap-24">
          {items.map((s, idx) => (
            <article
              key={s.id}
              data-testid={`story-${s.id}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center ${idx % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}
            >
              <div className="md:col-span-6 grid grid-cols-2 gap-2 md:gap-3">
                {(s.images || []).slice(0, 3).map((img, i) => (
                  <div key={i} className={`hover-scale ${i === 0 ? "col-span-2 aspect-[16/10]" : "aspect-[4/5]"}`}>
                    <img src={img.url} alt={s.title} loading="lazy" className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              <div className="md:col-span-6 md:pl-6">
                <div className="eyebrow text-[color:var(--text-muted)] mb-3">{s.location}</div>
                <h3 className="font-display italic text-3xl md:text-5xl leading-[1] tracking-tight mb-6">{s.title}</h3>
                {s.short_story && <p className="text-[color:var(--text-muted)] leading-relaxed max-w-lg mb-6">{s.short_story}</p>}
                <div className="grid grid-cols-1 gap-4 pt-6 border-t border-[color:var(--border)] max-w-md">
                  {s.design_direction && (
                    <div>
                      <div className="eyebrow mb-1">Design Direction</div>
                      <div className="text-sm">{s.design_direction}</div>
                    </div>
                  )}
                  {s.favourite_detail && (
                    <div>
                      <div className="eyebrow mb-1">Favourite Detail</div>
                      <div className="text-sm">{s.favourite_detail}</div>
                    </div>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
